import { render, staticRenderFns } from "./mis_datos.vue?vue&type=template&id=3987c7ea&scoped=true"
import script from "./mis_datos.vue?vue&type=script&lang=js"
export * from "./mis_datos.vue?vue&type=script&lang=js"
import style0 from "./mis_datos.vue?vue&type=style&index=0&id=3987c7ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3987c7ea",
  null
  
)

export default component.exports